import { Component, type ErrorInfo, type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * GRANICA BŁĘDU — kawałek ekranu, który padł, nie może zabrać ze sobą całego portalu.
 *
 * ⚠️⚠️ POWSTAŁO PO ZGŁOSZENIU Z FIREFOKSA (14.08.2026): „mruga, że zaczyna ładować, a potem mam
 * całą białą stronę i nic się nie dzieje". To nie był błąd widoku 3D jako takiego — to była JEGO
 * KONSEKWENCJA. React od wersji 16 przy wyjątku, którego nikt nie złapał, **odmontowuje całe
 * drzewo**: zamiast zepsutego prostokąta zostaje pusty dokument, bez komunikatu i bez nawigacji,
 * więc nie da się nawet wrócić na inny ekran.
 *
 * ⚠️ TREŚĆ BŁĘDU POKAZUJEMY WPROST, nie chowamy w konsoli. Ekran u klienta ogląda człowiek, który
 * nie otworzy narzędzi deweloperskich — a bez treści zgłoszenie brzmi „nie działa" i zaczyna się
 * zgadywanie. Zdanie z wyjątku wystarcza zwykle do rozpoznania przyczyny bez dostępu do maszyny.
 */
export class GranicaBledu extends Component<
  { children: ReactNode; tytul: string; opis?: string },
  { blad: Error | null }
> {
  override state: { blad: Error | null } = { blad: null };

  static getDerivedStateFromError(blad: Error): { blad: Error } {
    return { blad };
  }

  override componentDidCatch(blad: Error, gdzie: ErrorInfo): void {
    /** Konsola dostaje komplet ze stosem — ekran tylko zdanie. */
    console.error('[granica błędu]', blad, gdzie.componentStack);
  }

  override render(): ReactNode {
    const { blad } = this.state;
    if (blad === null) return this.props.children;

    return (
      <div className="flex min-h-[200px] flex-col items-center justify-center gap-2 rounded-lg border border-[var(--destructive)]/40 bg-[var(--destructive)]/5 p-6 text-center">
        <AlertTriangle className="size-5 text-[var(--destructive)]" />
        <p className="text-sm font-medium">{this.props.tytul}</p>
        {this.props.opis !== undefined && <p className="text-xs text-muted-foreground">{this.props.opis}</p>}
        <p className="max-w-xl break-words font-mono text-[11px] text-muted-foreground">{blad.message}</p>
      </div>
    );
  }
}
